export const MAX_BIRTHDAY_YEAR = 'January 1, 1900';
